module.exports = __webpack_public_path__ + "static/media/warehouse-1.14338db0.jpeg";